import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Container,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Avatar,
  Paper,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton as MuiIconButton,
  useMediaQuery,
  useTheme,
  Slider,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import axios from "axios";

// Import all resume components
import Resume1 from "./DuplicateResume/Resume1";
import Resume2 from "./DuplicateResume/Resume2";
import Resume3 from "./DuplicateResume/Resume3";
import Resume4 from "./DuplicateResume/Resume4";
import Resume5 from "./DuplicateResume/Resume5";
import Resume6 from "./DuplicateResume/Resume6";
import Resume7 from "./DuplicateResume/Resume7";
import Resume8 from "./DuplicateResume/Resume8";
import Resume9 from "./DuplicateResume/Resume9";
import Resume10 from "./DuplicateResume/Resume10";
import Resume11 from "./DuplicateResume/Resume11";
import Resume12 from "./DuplicateResume/Resume12";
import Resume13 from "./DuplicateResume/Resume13";
import Resume14 from "./DuplicateResume/Resume14";
import Resume15 from "./DuplicateResume/Resume15";
import Resume16 from "./DuplicateResume/Resume16";
import Resume17 from "./DuplicateResume/Resume17";
import Resume18 from "./DuplicateResume/Resume18";
import Resume19 from "./DuplicateResume/Resume19";
import Resume20 from "./DuplicateResume/Resume20";
import Resume21 from "./DuplicateResume/Resume21";
import Resume22 from "./DuplicateResume/Resume22";
import Resume23 from "./DuplicateResume/Resume23";
import Resume24 from "./DuplicateResume/Resume24";
import Resume25 from "./DuplicateResume/Resume25";
import Resume26 from "./DuplicateResume/Resume26";
import Resume27 from "./DuplicateResume/Resume27";
import Resume28 from "./DuplicateResume/Resume28";
import Resume29 from "./DuplicateResume/Resume29";
import Resume30 from "./DuplicateResume/Resume30";
import Resume31 from "./DuplicateResume/Resume31";
import Resume32 from "./DuplicateResume/Resume32";
import Resume33 from "./DuplicateResume/Resume33";
import Resume34 from "./DuplicateResume/Resume34";
import Resume35 from "./DuplicateResume/Resume35";
import Resume36 from "./DuplicateResume/Resume36";
import Resume37 from "./DuplicateResume/Resume37";
import Resume38 from "./DuplicateResume/Resume38";
import Resume39 from "./DuplicateResume/Resume39";
import Resume40 from "./DuplicateResume/Resume40";
import Resume41 from "./DuplicateResume/Resume41";
import Resume42 from "./DuplicateResume/Resume42";
import Resume43 from "./DuplicateResume/Resume43";
import Resume44 from "./DuplicateResume/Resume44";
import Resume45 from "./DuplicateResume/Resume45";
import Resume46 from "./DuplicateResume/Resume46";
import Resume47 from "./DuplicateResume/Resume47";
import Resume48 from "./DuplicateResume/Resume48";
import Resume49 from "./DuplicateResume/Resume49";
import Resume50 from "./DuplicateResume/Resume50";

const templateComponents = {
  1: Resume1, 2: Resume2, 3: Resume3, 4: Resume4, 5: Resume5,
  6: Resume6, 7: Resume7, 8: Resume8, 9: Resume9, 10: Resume10,
  11: Resume11, 12: Resume12, 13: Resume13, 14: Resume14, 15: Resume15,
  16: Resume16, 17: Resume17, 18: Resume18, 19: Resume19, 20: Resume20,
  21: Resume21, 22: Resume22, 23: Resume23, 24: Resume24, 25: Resume25,
  26: Resume26, 27: Resume27, 28: Resume28, 29: Resume29, 30: Resume30,
  31: Resume31, 32: Resume32, 33: Resume33, 34: Resume34, 35: Resume35,
  36: Resume36, 37: Resume37, 38: Resume38, 39: Resume39, 40: Resume40,
  41: Resume41, 42: Resume42, 43: Resume43, 44: Resume44, 45: Resume45,
  46: Resume46, 47: Resume47, 48: Resume48, 49: Resume49, 50: Resume50,
};

// Template IDs that should NOT show or accept a photo (auto-detected from resume components)
const NO_IMAGE_TEMPLATES = [6,8,12,18,19,20,21,27,28,29,30,31,32,33,34,35,43,44,45,46,49];

const countries = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia",
  "Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium",
  "Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria",
  "Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad",
  "Chile","China","Colombia","Comoros","Congo, Democratic Republic of the","Congo, Republic of the",
  "Costa Rica","Côte d'Ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti",
  "Dominica","Dominican Republic","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea",
  "Eritrea","Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia",
  "Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti",
  "Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy",
  "Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Korea, North","Korea, South","Kosovo",
  "Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein",
  "Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands",
  "Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco",
  "Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger",
  "Nigeria","North Macedonia","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea",
  "Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino",
  "Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore",
  "Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Sudan","Spain","Sri Lanka",
  "Sudan","Suriname","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand",
  "Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine",
  "United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City",
  "Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
];

const ContactForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    city: "",
    country: "India",
    pinCode: "",
    phone: "",
    email: "",
    currentPosition: "",
    linkedIn: "",
  });

  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState("");
  const [photoRemoved, setPhotoRemoved] = useState(false);

  // ── Crop state ──────────────────────────────────────────────────────────────
  const [cropDialogOpen, setCropDialogOpen] = useState(false);
  const [rawImageSrc, setRawImageSrc] = useState("");
  const [cropZoom, setCropZoom] = useState(1);
  const [cropOffset, setCropOffset] = useState({ x: 0, y: 0 });
  const [cropType, setCropType] = useState("circle"); // "circle" | "square"
  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const dragOffset = useRef({ x: 0, y: 0 });

  const [selectedTemplate, setSelectedTemplate] = useState(() => {
    const navTemplate = location.state?.selectedTemplate;
    if (navTemplate) {
      localStorage.setItem("selectedTemplate", navTemplate);
      return navTemplate;
    }
    return localStorage.getItem("selectedTemplate") || 1;
  });

  const templateSupportsPhoto = !NO_IMAGE_TEMPLATES.includes(Number(selectedTemplate));

  const [selectedTheme, setSelectedTheme] = useState(() => {
    const navTheme = location.state?.selectedTheme;
    const parseTheme = (t) => {
      if (!t) return null;
      if (typeof t === "string") return t;
      if (typeof t === "object") return t.primary || t.color || t.highlight || t.primary?.main || t.hex || null;
      return null;
    };
    const fromNav = parseTheme(navTheme);
    if (fromNav) { localStorage.setItem("selectedTheme", fromNav); return fromNav; }
    const stored = localStorage.getItem("selectedTheme");
    if (!stored) return "#1a2b47";
    try {
      const parsed = JSON.parse(stored);
      const fromParsed = parseTheme(parsed);
      return fromParsed || stored || "#1a2b47";
    } catch { return stored; }
  });

  const [showLinkedIn, setShowLinkedIn] = useState(false);
  const [showWebsite, setShowWebsite] = useState(false);
  const [showDL, setShowDL] = useState(false);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewScale, setPreviewScale] = useState(0.85);

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: template, selectedTheme: theme } = location.state;
      if (template) {
        setSelectedTemplate(template);
        localStorage.setItem("selectedTemplate", template);
      }
      if (theme) {
        const normalized = typeof theme === "string"
          ? theme
          : (theme.primary || theme.color || theme.highlight || theme.primary?.main || theme.hex || null);
        if (normalized) {
          setSelectedTheme(normalized);
          localStorage.setItem("selectedTheme", normalized);
        }
      }
    }
  }, [location.state]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        const res = await axios.get("https://resume-maker-lc.onrender.com/api/contact/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data) {
          setFormData({
            firstName: res.data.firstName || "",
            lastName: res.data.lastName || "",
            city: res.data.city || "",
            country: res.data.country || "India",
            pinCode: res.data.pinCode || "",
            phone: res.data.phone || "",
            email: res.data.email || "",
            currentPosition: res.data.currentPosition || "",
            linkedIn: res.data.linkedIn || "",
          });
          if (res.data.photo) {
            setPreview(
              res.data.photo.startsWith("http")
                ? res.data.photo
                : `https://resume-maker-lc.onrender.com${res.data.photo}`
            );
          }
        }
      } catch (err) {
        console.error("Error fetching contact", err);
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("token");
          alert("Session expired. Please login again.");
          navigate("/Signup");
        }
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleCountryChange = (e) => setFormData({ ...formData, country: e.target.value });

  // ── Open crop dialog when user picks a file ─────────────────────────────────
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    setRawImageSrc(objectUrl);
    setCropZoom(1);
    setCropOffset({ x: 0, y: 0 });
    dragOffset.current = { x: 0, y: 0 };
    setCropDialogOpen(true);
    // Reset input so same file can be re-selected
    e.target.value = "";
  };

  // ── Draw crop preview on canvas (supports circle + square) ─────────────────
  const drawCrop = useCallback(() => {
    const canvas = canvasRef.current;
    const img = imgRef.current;
    if (!canvas || !img) return;
    const SIZE = 300;
    canvas.width = SIZE;
    canvas.height = SIZE;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, SIZE, SIZE);

    // Background fill so square edges are visible
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, SIZE, SIZE);

    ctx.save();
    if (cropType === "circle") {
      ctx.beginPath();
      ctx.arc(SIZE / 2, SIZE / 2, SIZE / 2, 0, Math.PI * 2);
      ctx.clip();
    }
    // Square: no clip needed, full canvas is the crop area

    const drawW = img.naturalWidth * cropZoom;
    const drawH = img.naturalHeight * cropZoom;
    const x = SIZE / 2 - drawW / 2 + cropOffset.x;
    const y = SIZE / 2 - drawH / 2 + cropOffset.y;
    ctx.drawImage(img, x, y, drawW, drawH);
    ctx.restore();

    // Border
    ctx.beginPath();
    if (cropType === "circle") {
      ctx.arc(SIZE / 2, SIZE / 2, SIZE / 2 - 1, 0, Math.PI * 2);
    } else {
      ctx.rect(1, 1, SIZE - 2, SIZE - 2);
    }
    ctx.strokeStyle = "#24c6ef";
    ctx.lineWidth = 2.5;
    ctx.stroke();
  }, [cropZoom, cropOffset, cropType]);

  useEffect(() => {
    if (cropDialogOpen) drawCrop();
  }, [cropDialogOpen, drawCrop]);

  // ── Mouse / touch drag handlers ──────────────────────────────────────────────
  const onMouseDown = (e) => {
    isDragging.current = true;
    dragStart.current = { x: e.clientX - cropOffset.x, y: e.clientY - cropOffset.y };
  };
  const onMouseMove = (e) => {
    if (!isDragging.current) return;
    const newOffset = { x: e.clientX - dragStart.current.x, y: e.clientY - dragStart.current.y };
    setCropOffset(newOffset);
  };
  const onMouseUp = () => { isDragging.current = false; };

  const onTouchStart = (e) => {
    const t = e.touches[0];
    isDragging.current = true;
    dragStart.current = { x: t.clientX - cropOffset.x, y: t.clientY - cropOffset.y };
  };
  const onTouchMove = (e) => {
    if (!isDragging.current) return;
    const t = e.touches[0];
    const newOffset = { x: t.clientX - dragStart.current.x, y: t.clientY - dragStart.current.y };
    setCropOffset(newOffset);
  };
  const onTouchEnd = () => { isDragging.current = false; };

  // ── Reset zoom/offset when crop type changes ────────────────────────────────
  const handleCropTypeChange = (type) => {
    setCropType(type);
    setCropZoom(1);
    setCropOffset({ x: 0, y: 0 });
    dragOffset.current = { x: 0, y: 0 };
  };

  // ── Confirm crop: export canvas as blob → use as photo ───────────────────────
  const handleCropConfirm = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.toBlob((blob) => {
      const croppedFile = new File([blob], "cropped-photo.png", { type: "image/png" });
      setPhoto(croppedFile);
      setPreview(URL.createObjectURL(blob));
      setPhotoRemoved(false); // new photo selected, clear the removed flag
      setCropDialogOpen(false);
    }, "image/png");
  };

  const handleCropCancel = () => {
    setCropDialogOpen(false);
    setRawImageSrc("");
  };

  // ── Remove / delete photo ────────────────────────────────────────────────────
  const handleRemovePhoto = async () => {
    // 1. Clear local state immediately
    setPhoto(null);
    setPreview("");
    setPhotoRemoved(true);

    // 2. Persist removal to server right away so refresh shows no image
    try {
      const token = localStorage.getItem("token");
      const data = new FormData();
      // Send all existing formData fields so we don't wipe them
      for (const key in formData) data.append(key, formData[key]);
      data.append("removePhoto", "true");
      await axios.post("https://resume-maker-lc.onrender.com/api/contact/save", data, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
    } catch (err) {
      console.error("Error removing photo:", err.message);
    }
  };

  const handleOpenPreview = () => {
    setPreviewScale(isMobile ? 0.46 : 0.85);
    setOpenPreviewDialog(true);
  };
  const handleClosePreview = () => setOpenPreviewDialog(false);

  const SelectedResumeComponent = templateComponents[selectedTemplate];

  const getResumeProps = () => {
    const commonProps = {
      color: selectedTheme,
      formData,
      photo: templateSupportsPhoto ? preview : "",
      linkedIn: formData.linkedIn || "",
      website: formData.website || "",
      drivingLicence: formData.drivingLicence || "",
    };
    switch (selectedTemplate) {
      case 2: return { ...commonProps, color: selectedTheme };
      case 3: return { ...commonProps, color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme };
      case 4: return { ...commonProps, theme: selectedTheme, color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme };
      case 7: return { ...commonProps, theme: selectedTheme, color: typeof selectedTheme === "object" ? selectedTheme.highlight : selectedTheme };
      case 8: return { ...commonProps, theme: selectedTheme };
      default: return commonProps;
    }
  };

  const handleSaveAndNext = async () => {
    try {
      if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone) {
        alert("First name, Last name, Email, and Phone are required!");
        return;
      }
      const token = localStorage.getItem("token");
      const data = new FormData();
      for (const key in formData) data.append(key, formData[key]);
      if (photo && templateSupportsPhoto) data.append("photo", photo);
      // If user removed photo and didn't pick a new one, tell server to clear it
      if (photoRemoved && !photo) data.append("removePhoto", "true");
      await axios.post("https://resume-maker-lc.onrender.com/api/contact/save", data, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
      navigate("/WorkHistry", { state: { selectedTemplate, selectedTheme } });
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Error saving contact");
    }
  };

  return (
    <>
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      {/* Main content area — pushed right of sidebar */}
      <Box
        sx={{
          ml: { xs: "60px", sm: "240px" },
          width: { xs: "calc(100% - 60px)", sm: "calc(100% - 240px)" },
          minHeight: "100vh",
          p: { xs: 1.5, sm: 3 },
          boxSizing: "border-box",
        }}
      >
        {/* On desktop: side-by-side; on mobile: stacked */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 2,
            alignItems: "flex-start",
          }}
        >
          {/* ===== LEFT: Contact Form ===== */}
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 4 },
              width: { xs: "100%", md: "55%" },
              boxSizing: "border-box",
            }}
          >
            {/* Go back button */}
            <Box sx={{ mb: 2 }}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/resume")}
                size="small"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderColor: "#24c6ef",
                  color: "#24c6ef",
                  borderRadius: 2,
                  "&:hover": {
                    borderColor: "#1daed8",
                    backgroundColor: "rgba(36, 198, 239, 0.06)",
                    color: "#1daed8",
                  },
                }}
              >
                Go to Back
              </Button>
            </Box>

            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              sx={{ color: "#24c6ef", fontSize: { xs: "1.1rem", sm: "1.5rem" } }}
            >
              What's the preferred way for employers to connect with you?
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              For better communication, you must share your email and phone details.
            </Typography>

            <Grid container spacing={3} sx={{ mt: 1 }}>
              {/* Avatar + Upload */}
              <Grid item xs={12} sm={3} sx={{ textAlign: "center" }}>
              {templateSupportsPhoto ? (
                <>
                  {/* Avatar with hover remove overlay */}
                  <Box
                    sx={{
                      position: "relative",
                      width: { xs: 80, sm: 100 },
                      height: { xs: 80, sm: 100 },
                      mx: "auto",
                      mb: 1.5,
                      "&:hover .remove-overlay": { opacity: preview ? 1 : 0 },
                    }}
                  >
                    <Avatar
                      src={preview || (formData.photo ? `https://resume-maker-lc.onrender.com${formData.photo}` : "")}
                      sx={{ width: "100%", height: "100%" }}
                    />
                    {/* Red X overlay on hover */}
                    {preview && (
                      <Box
                        className="remove-overlay"
                        onClick={handleRemovePhoto}
                        sx={{
                          position: "absolute",
                          top: 0, left: 0,
                          width: "100%", height: "100%",
                          borderRadius: "50%",
                          bgcolor: "rgba(211,47,47,0.75)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: 0,
                          transition: "opacity 0.2s",
                          cursor: "pointer",
                        }}
                      >
                        <DeleteIcon sx={{ color: "#fff", fontSize: { xs: 22, sm: 28 } }} />
                      </Box>
                    )}
                  </Box>

                  {/* Upload button */}
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    size="small"
                    sx={{ textTransform: "none", fontSize: { xs: "0.75rem", sm: "0.875rem" }, mb: preview ? 1 : 0 }}
                  >
                    {preview ? "Change Photo" : "Upload Photo"}
                    <input hidden accept="image/*" type="file" onChange={handleFileChange} />
                  </Button>

                  {/* Remove button — only when photo exists */}
                  {preview && (
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<DeleteIcon />}
                      onClick={handleRemovePhoto}
                      sx={{
                        textTransform: "none",
                        fontSize: { xs: "0.72rem", sm: "0.8rem" },
                        borderColor: "#f44336",
                        color: "#f44336",
                        display: "block",
                        mx: "auto",
                        mt: 0.5,
                        "&:hover": { bgcolor: "rgba(244,67,54,0.06)", borderColor: "#d32f2f" },
                      }}
                    >
                      Remove Photo
                    </Button>
                  )}
                </>
              ) : (
                <>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1 }}>
                    This template does not include a photo.
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    size="small"
                    disabled
                    sx={{ textTransform: "none", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    Upload Photo
                  </Button>
                </>
              )}
              </Grid>

              {/* Form Fields */}
              <Grid item xs={12} sm={9}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="City"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={8} sm={3}>
                    <FormControl fullWidth size={isMobile ? "small" : "medium"}>
                      <InputLabel>Country</InputLabel>
                      <Select
                        value={formData.country}
                        onChange={handleCountryChange}
                        label="Country"
                        name="country"
                      >
                        {countries.map((country) => (
                          <MenuItem key={country} value={country}>{country}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={3}>
                    <TextField
                      fullWidth
                      label="Pin Code"
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleChange}
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 22 1234 5677"
                      required
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="spatel@sample.in"
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Current Position"
                      name="currentPosition"
                      value={formData.currentPosition}
                      onChange={handleChange}
                      placeholder="e.g., Software Engineer, Project Manager"
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Add More Contact Details */}
            <Box sx={{ mt: 4 }}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: "#555" }}>
                Add More Contact Details
              </Typography>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size={isMobile ? "small" : "medium"}
                  onClick={() => setShowLinkedIn(!showLinkedIn)}
                >
                  LinkedIn
                </Button>
              </Box>
              <Grid container spacing={2}>
                {showLinkedIn && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Enter LinkedIn URL"
                      name="linkedIn"
                      value={formData.linkedIn}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                )}
                {showWebsite && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Enter Website URL"
                      name="website"
                      value={formData.website}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                )}
                {showDL && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Enter Driving Licence Number"
                      name="drivingLicence"
                      value={formData.drivingLicence}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      size={isMobile ? "small" : "medium"}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Bottom Buttons */}
            <Box
              sx={{
                mt: 4,
                display: "flex",
                gap: 2,
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "flex-start",
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  fontWeight: "bold",
                  height: 45,
                  minWidth: { xs: "100%", sm: 120 },
                  "&:hover": {
                    borderColor: "#24c6ef",
                    color: "#24c6ef",
                    backgroundColor: "rgba(36, 198, 239, 0.04)",
                  },
                }}
                onClick={handleOpenPreview}
              >
                Preview
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#24c6ef",
                  "&:hover": { backgroundColor: "#1daed8" },
                  minWidth: { xs: "100%", sm: 200 },
                  borderRadius: 3,
                  fontWeight: "bold",
                  height: 45,
                }}
                onClick={handleSaveAndNext}
              >
                Save & Next: Work History
              </Button>
            </Box>
          </Paper>

          {/* ===== RIGHT: Resume Preview (hidden on mobile, shown in dialog instead) ===== */}
          {!isMobile && (
            <Box
              sx={{
                width: "45%",
                position: "sticky",
                top: 0,
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                bgcolor: "#f1f5f9",
                borderRadius: 2,
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              }}
            >
              {/* Header bar */}
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  borderBottom: "1px solid #e2e8f0",
                  bgcolor: "#fff",
                  borderRadius: "8px 8px 0 0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 10, height: 10, borderRadius: "50%", bgcolor: "#f87171",
                  }}
                />
                <Box
                  sx={{
                    width: 10, height: 10, borderRadius: "50%", bgcolor: "#fbbf24",
                  }}
                />
                <Box
                  sx={{
                    width: 10, height: 10, borderRadius: "50%", bgcolor: "#34d399",
                  }}
                />
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  sx={{ ml: 1, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", fontSize: "0.65rem" }}
                >
                  Live Preview
                </Typography>
              </Box>

              {/* Scrollable preview area */}
              <Box
                sx={{
                  flexGrow: 1,
                  overflow: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  p: 2,
                  // Custom slim scrollbar
                  "&::-webkit-scrollbar": { width: "5px" },
                  "&::-webkit-scrollbar-track": { background: "transparent" },
                  "&::-webkit-scrollbar-thumb": { background: "#cbd5e1", borderRadius: "10px" },
                }}
              >
                {/*
                  ── KEY CHANGE ──
                  The resume (794px wide A4) is scaled to fit the ~45% panel width.
                  Panel width ≈ 45% of (100vw - 240px sidebar) ≈ 45% of ~1100px ≈ 495px
                  We want the resume to fill ~90% of that → target ≈ 445px
                  Scale factor = 445 / 794 ≈ 0.56
                  transformOrigin "top center" keeps it pinned at the top.
                  A negative bottom margin removes the whitespace created by scaling down.
                */}
                <Box
                  sx={{
                    transform: "scale(0.56)",
                    transformOrigin: "top center",
                    width: "794px",          // real A4 pixel width
                    flexShrink: 0,
                    mb: `calc(-1123px * (1 - 0.56))`, // collapse the vertical gap
                  }}
                >
                  <SelectedResumeComponent {...getResumeProps()} />
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* ===== Preview Dialog ===== */}
      <Dialog
        open={openPreviewDialog}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 2 },
            maxHeight: { xs: "100vh", sm: "90vh" },
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#f5f5f5",
            borderBottom: "1px solid #e0e0e0",
            py: 2,
            px: 3,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Resume Preview
          </Typography>

          <Box display="flex" alignItems="center" gap={1} sx={{ bgcolor: "#fff", px: 2, py: 0.5, borderRadius: "20px", border: "1px solid #ddd" }}>
            <MuiIconButton 
              size="small" 
              onClick={() => setPreviewScale(prev => Math.max(0.3, prev - 0.1))} 
              disabled={previewScale <= 0.3}
              sx={{ p: 0.5 }}
            >
              <ZoomOutIcon fontSize="small" />
            </MuiIconButton>
            <Typography variant="body2" sx={{ fontWeight: "bold", minWidth: "45px", textAlign: "center" }}>
              {Math.round(previewScale * 100)}%
            </Typography>
            <MuiIconButton 
              size="small" 
              onClick={() => setPreviewScale(prev => Math.min(2.0, prev + 0.1))} 
              disabled={previewScale >= 2.0}
              sx={{ p: 0.5 }}
            >
              <ZoomInIcon fontSize="small" />
            </MuiIconButton>
          </Box>

          <MuiIconButton
            onClick={handleClosePreview}
            size="small"
            sx={{
              color: "text.secondary",
              "&:hover": { color: "#24c6ef", backgroundColor: "rgba(36, 198, 239, 0.04)" },
            }}
          >
            <CloseIcon />
          </MuiIconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: { xs: 1, sm: 4 },
            overflow: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Box
            sx={{
              width: "800px",
              flexShrink: 0,
              transform: `scale(${previewScale})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease-in-out",
              marginLeft: `calc((800px * ${previewScale} - 800px) / 2)`,
              marginRight: `calc((800px * ${previewScale} - 800px) / 2)`,
              marginBottom: `calc((800px * ${previewScale} - 800px) / 2)`,
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              borderRadius: 1,
              backgroundColor: "white",
            }}
          >
            <SelectedResumeComponent {...getResumeProps()} />
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            padding: 3,
            backgroundColor: "#f5f5f5",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Button
            onClick={handleClosePreview}
            variant="contained"
            fullWidth={isMobile}
            sx={{
              backgroundColor: "#24c6ef",
              "&:hover": { backgroundColor: "#1daed8" },
              fontWeight: "bold",
              borderRadius: 2,
              px: 4,
              py: 1,
            }}
          >
            Close Preview
          </Button>
        </DialogActions>
      </Dialog>
    </Box>

      {/* ===== Image Crop Dialog ===== */}
      <Dialog
        open={cropDialogOpen}
        onClose={handleCropCancel}
        maxWidth="xs"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 3 },
            overflow: "hidden",
            m: { xs: 0, sm: 2 },
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 1.5,
            px: { xs: 2, sm: 3 },
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: "#f8fafe",
          }}
        >
          <Typography fontWeight="bold" fontSize={{ xs: "1rem", sm: "1.1rem" }}>
            ✂️ Crop Your Photo
          </Typography>
          <MuiIconButton size="small" onClick={handleCropCancel}>
            <CloseIcon fontSize="small" />
          </MuiIconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            pt: { xs: 1.5, sm: 2 },
            pb: { xs: 1, sm: 2 },
            px: { xs: 1.5, sm: 3 },
            overflowX: "hidden",
          }}
        >
          {/* ─ Crop Type Toggle ─ */}
          <Box
            sx={{
              display: "flex",
              width: "100%",
              borderRadius: 2,
              overflow: "hidden",
              border: "1.5px solid #24c6ef",
            }}
          >
            {["circle", "square"].map((type) => (
              <Box
                key={type}
                onClick={() => handleCropTypeChange(type)}
                sx={{
                  flex: 1,
                  py: { xs: 0.8, sm: 1 },
                  textAlign: "center",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: { xs: "0.78rem", sm: "0.875rem" },
                  transition: "all 0.2s",
                  bgcolor: cropType === type ? "#24c6ef" : "transparent",
                  color: cropType === type ? "#fff" : "#24c6ef",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                  userSelect: "none",
                }}
              >
                {type === "circle" ? "⬤ Circle" : "■ Square"}
              </Box>
            ))}
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", fontSize: { xs: "0.72rem", sm: "0.8rem" } }}>
            Drag to reposition · Use slider to zoom
          </Typography>

          {/* Hidden img used for drawing */}
          {rawImageSrc && (
            <img
              ref={imgRef}
              src={rawImageSrc}
              alt=""
              style={{ display: "none" }}
              onLoad={drawCrop}
            />
          )}

          {/* Crop canvas */}
          <Box
            sx={{
              borderRadius: cropType === "circle" ? "50%" : "12px",
              overflow: "hidden",
              border: "2.5px solid #24c6ef",
              cursor: "grab",
              userSelect: "none",
              "&:active": { cursor: "grabbing" },
              boxShadow: "0 4px 24px rgba(36,198,239,0.25)",
              width: { xs: 220, sm: 260 },
              height: { xs: 220, sm: 260 },
              flexShrink: 0,
              transition: "border-radius 0.25s",
            }}
          >
            <canvas
              ref={canvasRef}
              width={300}
              height={300}
              style={{ display: "block", width: "100%", height: "100%" }}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseUp}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            />
          </Box>

          {/* Zoom slider */}
          <Box sx={{ width: "100%", px: { xs: 0.5, sm: 1 } }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                🔍 Zoom
              </Typography>
              <Typography variant="caption" color="#24c6ef" fontWeight={700}>
                {Math.round(cropZoom * 100)}%
              </Typography>
            </Box>
            <Slider
              min={0.5}
              max={3}
              step={0.05}
              value={cropZoom}
              onChange={(_, v) => setCropZoom(v)}
              sx={{
                color: "#24c6ef",
                height: 6,
                "& .MuiSlider-thumb": { width: 18, height: 18 },
              }}
            />
          </Box>
        </DialogContent>

        {/* Actions */}
        <DialogActions
          sx={{
            px: { xs: 2, sm: 3 },
            pb: { xs: 2.5, sm: 2 },
            pt: 1,
            gap: 1.5,
            borderTop: "1px solid",
            borderColor: "divider",
            bgcolor: "#f8fafe",
          }}
        >
          <Button
            onClick={handleCropCancel}
            variant="outlined"
            fullWidth={isMobile}
            sx={{
              borderRadius: 2, textTransform: "none", flex: 1,
              borderColor: "#ccc", color: "#555",
              py: { xs: 1, sm: 0.75 },
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCropConfirm}
            variant="contained"
            fullWidth={isMobile}
            sx={{
              borderRadius: 2, textTransform: "none", flex: 1,
              bgcolor: "#24c6ef", "&:hover": { bgcolor: "#1daed8" },
              fontWeight: "bold",
              py: { xs: 1, sm: 0.75 },
            }}
          >
            Crop &amp; Use
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContactForm;